import { 
    FETCH_TIPOS_ADQUIRIENTES, 
    FETCH_SITUACION_IVA, 
    FETCH_TIPOS_SEXO, 
    FETCH_TIPOS_CONCEPTOS,
    LOADING_TIPOS_CONCEPTOS,
    UPDATE_TIPOS_CONCEPTOS_LIST,
    REMOVE_TIPOS_CONCEPTOS_LIST
} from '../actions/types';

const initialState = {
    loadingTipos: false,
    tipoSexo: [],
    adquirientes: [],
    situacionIva: [],
    tipoLiquidacionConcepto: []
}

function coincideConcepto(item, payload) {
    const idConceptoItem = String(item?.idConcepto ?? item?.IdConcepto ?? item?.concepto ?? item?.Concepto ?? "");
    const idConceptoPayload = String(payload?.idConcepto ?? payload?.IdConcepto ?? payload?.concepto ?? payload?.Concepto ?? "");
    const idTipoItem = String(item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idSubTipo ?? item?.IdSubTipo ?? "");
    const idTipoPayload = String(payload?.idTipoNovedad ?? payload?.IdTipoNovedad ?? payload?.idSubTipo ?? payload?.IdSubTipo ?? "");

    return (idConceptoItem && idConceptoPayload && idConceptoItem === idConceptoPayload)
    || (idTipoItem && idConceptoPayload && idTipoItem === idConceptoPayload)
    || (idConceptoItem && idTipoPayload && idConceptoItem === idTipoPayload)
        || (idTipoItem && idTipoPayload && idTipoItem === idTipoPayload);
}

export default function (state = initialState, action) {
    
    switch(action.type) {

        case FETCH_TIPOS_ADQUIRIENTES:
            return{
                ...state,
                adquirientes:action.payload
            };

        case FETCH_SITUACION_IVA: 
            return {
                ...state,
                situacionIva: action.payload
            };

        case FETCH_TIPOS_SEXO: 
            return {
                ...state,
                tipoSexo: action.payload
            };

        case FETCH_TIPOS_CONCEPTOS:
            return {
                ...state,
                tipoLiquidacionConcepto: action.payload
            };

        case UPDATE_TIPOS_CONCEPTOS_LIST: {
            const payload = action.payload || {};
            return {
                ...state,
                tipoLiquidacionConcepto: state.tipoLiquidacionConcepto.map((item) => {
                    if (!coincideConcepto(item, payload)) return item;

                    return {
                        ...item,
                        ...payload,
                        idConcepto: payload.idConcepto ?? item.idConcepto,
                        idTipoNovedad: item.idTipoNovedad ?? item.idSubTipo,
                        idSubTipo: payload.idSubTipo ?? payload.idTipoNovedad ?? item.idSubTipo ?? item.idTipoNovedad,
                        detalleConcepto: payload.descripcion ?? payload.detalleConcepto ?? item.detalleConcepto,
                        descripcionSubTipoNovedad: payload.descripcionSubTipoNovedad ?? item.descripcionSubTipoNovedad,
                    };
                })
            };
        }

        case REMOVE_TIPOS_CONCEPTOS_LIST: {
            const idTipoNovedad = String(action.payload?.idTipoNovedad ?? action.payload?.IdTipoNovedad ?? "");
            return {
                ...state,
                tipoLiquidacionConcepto: state.tipoLiquidacionConcepto.filter((item) => {
                    const itemIdTipo = String(item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idSubTipo ?? item?.IdSubTipo ?? "");
                    const itemIdConcepto = String(item?.idConcepto ?? item?.IdConcepto ?? item?.concepto ?? item?.Concepto ?? "");
                    return itemIdTipo !== idTipoNovedad && itemIdConcepto !== idTipoNovedad;
                })
            };
        }

        case LOADING_TIPOS_CONCEPTOS:
            return {
                ...state,
                loadingTipos: action.payload
            };

        default: return state;
    }
}